document.addEventListener("DOMContentLoaded", function () {
  const parents = document.querySelectorAll(".menu-item-has-children > a");

  parents.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault(); // stop link navigation

      const parentLi = this.parentElement;
      parentLi.classList.toggle("open");
    });
  });
  const menuToggle = document.getElementById("menu-mobile__toggle");
  const menuMobile = document.querySelector(".menu-mobile");
  const menuList = document.querySelector(".menu-list");
  const body = document.body;

  menuToggle.addEventListener("click", function (e) {
    e.preventDefault();

    // toggle menu visibility
    menuList.classList.toggle("active");

    // toggle body scroll lock
    if (menuList.classList.contains("active")) {
      body.style.position = "fixed";
      body.style.top = `-${window.scrollY}px`;
      body.style.width = "100%";
    } else {
      const scrollY = body.style.top;
      body.style.position = "";
      body.style.top = "";
      body.style.width = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }

    // toggle hamburger / close icon
    menuMobile.classList.toggle("active");
  });
});
